function clickVariantsSwatch(){
  function intersectionCallback(entries, observer) {
    entries.forEach(entry => {
     if (entry.isIntersecting && ((window.location.href.includes("karabiner+farbe=Gold&filter.v.option.karabiner+farbe=Silber")) || (window.location.href.includes("karabiner+farbe=gold&filter.v.option.karabiner+farbe=silber")) ) ) {
       return
    }else if(entry.isIntersecting && (window.location.href.includes("karabiner+farbe=gold"))) {
       entry.target.querySelector('label[title="gold"]').click();
      }else if (entry.isIntersecting && (window.location.href.includes("karabiner+farbe=Gold"))) {
       entry.target.querySelector('label[title="Gold"]').click();
      }else if (entry.isIntersecting && (window.location.href.includes("karabiner+farbe=silber"))) {
      entry.target.querySelector('label[title="silber"]').click();
      }else if (entry.isIntersecting && (window.location.href.includes("karabiner+farbe=Silber"))) {
      entry.target.querySelector('label[title="Silber"]').click();
      }
    });
  }
  const observers = new IntersectionObserver(intersectionCallback);
  const productCards = document.querySelectorAll(".halo-column__item");
  productCards.forEach(card => {
    observers.observe(card);
  });
}

setTimeout(function(){clickVariantsSwatch()}, 250);



window.addEventListener("click", (e) => {
  if(window.location.href.includes("karabiner+farbe=gold") && (e.target.classList.contains("label-of-silber") )){
    e.preventDefault();
    var currentURL = window.location.href;
    var newURL = currentURL.replace("gold", "silber");
    window.location.href = newURL;
  }else if(window.location.href.includes("karabiner+farbe=silber") && (e.target.classList.contains("label-of-gold") )){
    e.preventDefault();
     var currentURL = window.location.href;
    var newURL = currentURL.replace("silber", "gold");
    window.location.href = newURL;
  } else if(window.location.href.includes("karabiner+farbe=Gold") && (e.target.classList.contains("label-of-Silber") )){
    e.preventDefault();
    var currentURL = window.location.href;
    var newURL = currentURL.replace("Gold", "Silber");
    window.location.href = newURL;
  }else if(window.location.href.includes("karabiner+farbe=Silber") && (e.target.classList.contains("label-of-Gold") )){
    e.preventDefault();
     var currentURL = window.location.href;
    var newURL = currentURL.replace("Silber", "Gold");
    window.location.href = newURL;
  }
})

const anchorTags = document.querySelectorAll('.product-card__link');
anchorTags.forEach(anchorTag => {
  const variantSoldoutValue = anchorTag.getAttribute('data-variant-soldout');
  const hrefValue = anchorTag.getAttribute('href');
  const variantToCheck = hrefValue.match(/variant=(\d+)/)[1];
  console.log("variantToCheck-", variantToCheck);
  if (variantSoldoutValue.includes(variantToCheck)) {
    anchorTag.closest('.halo-column__item').classList.add('hide');
  }
});

